import React from 'react';
import JournalPageCard from './JournalPageCard';

const JournalPage = ({title, createDate, updateDate, sections}) => { 
    return (
        <div className="h-center top-space bottom-space">
            <div className="w-60">
                <p className="f2 fw7 text-dark mt0 mb3">
                    {title} 
                </p>
                <p className="f6 fw7 text-dark mv0">
                    Date created: {createDate} 
                </p>
                <p className="f6 fw7 text-dark mt0 mb4">
                    Date updated: {updateDate} 
                </p>
                {sections.map((section, i) => {
                    return (
                        <div>
                            <JournalPageCard 
                                key={i}
                                header={section.header}
                                paragraphs={section.paragraphs}
                            />
                        </div>
                    )
                })}
            </div>
        </div>
    );
}

export default JournalPage; 